module.exports = __webpack_public_path__ + "static/media/hiventureslogo.b3f95809.png";